/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EligibilityCheck } from './EligibilityCheck';
import {
    EligibilityCheckFromJSON,
    EligibilityCheckFromJSONTyped,
    EligibilityCheckToJSON,
    EligibilityCheckToJSONTyped,
} from './EligibilityCheck';

/**
 * 
 * @export
 * @interface PerformEligibilityCheck200Response
 */
export interface PerformEligibilityCheck200Response {
    /**
     * 
     */
    data?: EligibilityCheck;
}

/**
 * Check if a given object implements the PerformEligibilityCheck200Response interface.
 */
export function instanceOfPerformEligibilityCheck200Response(value: object): value is PerformEligibilityCheck200Response {
    return true;
}

export function PerformEligibilityCheck200ResponseFromJSON(json: any): PerformEligibilityCheck200Response {
    return PerformEligibilityCheck200ResponseFromJSONTyped(json, false);
}

export function PerformEligibilityCheck200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PerformEligibilityCheck200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : EligibilityCheckFromJSON(json['data']),
    };
}

export function PerformEligibilityCheck200ResponseToJSON(json: any): PerformEligibilityCheck200Response {
    return PerformEligibilityCheck200ResponseToJSONTyped(json, false);
}

export function PerformEligibilityCheck200ResponseToJSONTyped(value?: PerformEligibilityCheck200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EligibilityCheckToJSON(value['data']),
    };
}

